/* src/app/components/user-data-stale-toast/user-data-stale-toast.component.scss */
:host {
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
}
:host .user-data-stale-toast {
  background-color: #FFD100;
  height: 42px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
}
:host .user-data-stale-toast .message {
  font-weight: 700;
  font-size: 14px;
  color: #212121;
}
/*# sourceMappingURL=user-data-stale-toast.component.css.map */
